import MyButton from "../../util/MyButton";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

//Icons
import FavoriteIcon from "@material-ui/icons/Favorite";
import FavoriteBorder from "@material-ui/icons/FavoriteBorder";

//Redux
import { connect } from "react-redux";
import { likePost, unlikePost } from "../../redux/actions/dataActions";

const LikeButton = (props) => {
  const {
    user,
    user: { authenticated },
  } = props;

  let likedPost = () => {
    if (user.likes && user.likes.find((like) => like.postId === props.postId))
      return true;
    else return false;
  };

  let likePost = () => {
    props.likePost(props.postId);
  };

  let unlikePost = () => {
    props.unlikePost(props.postId);
  };

  const likeButton = !authenticated ? (
    <Link to="/login">
      <MyButton tip="Like">
        <FavoriteBorder style={{fontSize:"15px"}} color="textSecondary"/>
      </MyButton>
    </Link>
  ) : likedPost() ? (
    <MyButton tip="Unlike" onClick={unlikePost}>
      <FavoriteIcon className="date" style={{color:"#FD1D1D"}} />
    </MyButton>
  ) : (
    <MyButton tip="Like" onClick={likePost}>
      <FavoriteBorder  color="textSecondary" />
    </MyButton>
  );

  return likeButton;
};

LikeButton.propTypes = {
  user: PropTypes.object.isRequired,
  postId: PropTypes.string.isRequired,
  likePost: PropTypes.func.isRequired,
  unlikePost: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapActionsToProps = {
  likePost,
  unlikePost,
};

export default connect(mapStateToProps, mapActionsToProps)(LikeButton);
